import React, {useState} from 'react';
import s from '../mobile.module.css';
import {Typography, Drawer, Button} from "antd";
import {UserOutlined, TeamOutlined, CommentOutlined} from '@ant-design/icons';

const {Text} = Typography;

/**
 * Компонент для отображения свойств плана команды с комментариями в выдвижной панели
 *
 * @param {Object} props - Свойства компонента
 * @param {Function} props.getStaffName - Функция для получения имени сотрудника по ID
 * @param {Object} props.currentTeam - Объект с данными текущей команды
 * @param {Array} props.plans - Массив планов
 */
const PlanProps = ({getStaffName, currentTeam, plans}) => {
    const [commentsVisible, setCommentsVisible] = useState(false);

    const staffIds = currentTeam.staff_id?.split(',') || [];
    const hasGeneralComment = Boolean(plans[0]?.maincomment);
    const hasTeamComment = Boolean(currentTeam.teamcomment);
    const hasAnyComment = hasGeneralComment || hasTeamComment;

    return (
        <div>
            <div>
                <UserOutlined style={{marginRight: '5px'}}/>
                <Text strong>Старший: </Text> {getStaffName(currentTeam.lead)}
            </div>

            <div>
                <UserOutlined style={{marginRight: '5px'}}/>
                <Text strong>Водитель: </Text> {getStaffName(currentTeam.driver)}
            </div>
            <div style={{marginTop: '20px', marginBottom: '40px'}}>
                <TeamOutlined style={{marginRight: '5px'}}/>
                <Text strong>Сотрудники:</Text>
                {currentTeam.staff_id?.split(',').map((staffId, index) => (
                    <div key={index} className={s.staffItem}>
                        • {getStaffName(staffId)}
                    </div>
                ))}
            </div>

            {/* Кнопка для показа комментариев */}
            {hasAnyComment && (
                <div className={s.btns__cont}>
                    <Button
                        type="default"
                        icon={<CommentOutlined/>}
                        onClick={() => setCommentsVisible(true)}
                        style={{marginBottom: '16px'}}
                    >
                        Комментарии
                    </Button>
                    <Button
                        type="default"
                        icon={<CommentOutlined/>}
                        onClick={(e) => {
                            e.stopPropagation();
                            window.open(`https://gdapp.org/current_plan/?id=${plans[0].id}`, '_blank');
                        }}
                        style={{marginBottom: '16px'}}
                    >
                        Открыть план
                    </Button>
                </div>

            )}

            {/* Выдвижная панель с комментариями */}
            <Drawer
                title="Комментарии"
                placement="bottom"
                closable={true}
                onClose={() => setCommentsVisible(false)}
                visible={commentsVisible}
                height="auto"
                style={{borderTopLeftRadius: '8px', borderTopRightRadius: '8px'}}
            >
                <div className={s.commentsContainer}>
                    {/* Общий комментарий */}
                    <div className={s.commentSection}>
                        <Text strong style={{display: 'block', marginBottom: '8px'}}>
                            Для всех:
                        </Text>
                        <div className={s.commentText}>
                            {plans[0]?.maincomment || 'Нет комментария'}
                        </div>
                    </div>

                    {/* Комментарий для команды */}
                    <div className={s.commentSection}>
                        <Text strong style={{display: 'block', marginBottom: '8px'}}>
                            Для команды:
                        </Text>
                        <div className={s.commentText}>
                            {currentTeam.teamcomment || 'Нет комментария'}
                        </div>
                    </div>
                </div>
            </Drawer>
        </div>
    );
};

export default PlanProps;